module.exports = __webpack_public_path__ + "static/media/crew-builder.b0e9d31c.gif";